import axiosAuth from '../../axiosMain';

async function index(consumption_category_id) {
  let response = await axiosAuth.get('/tips_by_consumption_category/' + consumption_category_id);
  return response.data.data;
}

export default {
  index,
};
